import { assign, filter, map, findIndex, cloneDeep, isUndefined } from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: { ValidationProvider, ValidationObserver },
  data() {
    const typeGroups = [
      "Base Types",
      "User Data Types",
      // "Native Data Types",
      "Function Block Types",
      "Array",
    ];

    return {
      search: '',
      dialog: false,
      dimensionDialog: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Class", value: "class" },
        { text: "Type", value: "type.name" },
        { text: "Location", value: "address" },
        { text: "Initial Value", value: "initialValue" },
        { text: "Option", value: "option" },
        { text: "Documentation", value: "documentation" },
        { text: "", value: "actions", sortable: false },
      ],
      dimensionHeaders: [
        {
          text: "Lower",
          sortable: false,
          value: "lower",
        },
        {
          text: "Upper",
          sortable: false,
          value: "upper",
        },
        { text: "", value: "actions", sortable: false },
      ],
      options: ["Constant", "Retain", "Non Retain"],
      typeGroup: typeGroups[0],
      typeGroups,
      baseTypes: [
        "BOOL",
        "SINT",
        "INT",
        "DINT",
        "LINT",
        "USINT",
        "UINT",
        "UDINT",
        "ULINT",
        "REAL",
        "LREAL",
        "TIME",
        "DATE",
        "TOD",
        "DT",
        "STRING",
        "BYTE",
        "WORD",
        "DWORD",
        "LWORD",
      ],
      editedVariable: {
        type: {},
      },
      editedDimension: {},
    };
  },
  computed: {
    formTitle() {
      return this.editedVariable.tempId ? "Edit Variable" : "New Variable";
    },
    userDataTypes() {
      return map(this.$store.state.dataTypes, "name");
    },
    functionBlockTypes() {
      return map(
        filter(this.$store.state.pous, { pouType: "functionBlock" }),
        "name"
      );
    },
    dimensionFormTitle() {
      if (this.editedVariable.type.name === "array") {
        return this.editedDimension.tempId ? "Edit Dimension" : "New Dimension";
      }

      return "";
    },
  },
  methods: {
    editVariable(item) {
      this.editedVariable = assign({}, item);
      this.dialog = true;

      if (item.type.name === "array") {
        this.typeGroup = "Array";
      } else if (this.baseTypes.includes(item.type.name)) {
        this.typeGroup = "Base Types";
      } else if (item.type.name === "derived") {
        this.typeGroup = "User Data Types";
      } else {
        this.typeGroup = "Function Block Types";
      }
    },
    resetDialog() {
      this.dialog = false;
      this.editedVariable = {
        type: {},
      };
      this.typeGroup = this.typeGroups[0];
    },
    resetDimensionDialog() {
      this.dimensionDialog = false;
    },
    addDimension() {
      this.editedDimension = {};
    },
    editDimension(value) {
      this.editedDimension = value;
      this.dimensionDialog = true;
    },
    saveDimension() {
      if (this.editedDimension.tempId) {
        let dimensions = cloneDeep(this.editedVariable.type.dimensions);

        const index = findIndex(dimensions, {
          tempId: this.editedDimension.tempId,
        });

        dimensions.splice(index, 1, this.editedDimension);

        this.editedVariable = {
          ...this.editedVariable,
          type: {
            ...this.editedVariable.type,
            dimensions,
          },
        };
      } else {
        let dimensions = cloneDeep(this.editedVariable.type.dimensions);

        if (isUndefined(dimensions)) {
          dimensions = [];
        }

        dimensions.push({
          ...this.editedDimension,
          tempId: this.uuid(),
        });

        this.editedVariable = {
          ...this.editedVariable,
          type: {
            ...this.editedVariable.type,
            dimensions,
          },
        };
      }

      this.resetDimensionDialog();
    },
    async deleteDimension({ tempId }) {
      if (
        await this.$confirm("Are you sure you want to delete this dimension?")
      ) {
        let dimensions = cloneDeep(this.editedVariable.type.dimensions);

        const index = findIndex(dimensions, {
          tempId,
        });

        dimensions.splice(index, 1);

        this.editedVariable = {
          ...this.editedVariable,
          type: {
            ...this.editedVariable.type,
            dimensions,
          },
        };
      }
    },
  },
};
